import { apiClient } from './client';
import { unwrapList } from './unwrap';
import type { AuditLogEntry } from './types';

/** Raw shape returned by GET /api/v1/audit-logs (Aperture.Application.Audit.Dtos.AuditLogDto). */
interface RawAuditLogDto {
  id: string;
  userId?: string | null;
  actorName?: string | null;
  actorEmail?: string | null;
  action: string;
  entityType: string;
  entityId?: string | null;
  detailsJson?: string | null;
  ipAddress?: string | null;
  createdAt: string;
}

function toAuditLogEntry(raw: RawAuditLogDto): AuditLogEntry {
  return {
    id: raw.id,
    actorId: raw.userId ?? undefined,
    actorName: raw.actorName ?? undefined,
    actorEmail: raw.actorEmail ?? undefined,
    action: raw.action,
    entityType: raw.entityType ?? undefined,
    entityId: raw.entityId ?? undefined,
    timestamp: raw.createdAt,
    details: raw.detailsJson ?? undefined,
  };
}

export const auditApi = {
  /**
   * Most recent audit log entries across the platform, newest first.
   * Backed by GET /api/v1/audit-logs (Phase 1 admin log viewer - no
   * server-side pagination/search yet, just a bounded "recent N" list).
   */
  recent: (limit = 100) =>
    apiClient
      .get('/audit-logs', { params: { limit } })
      .then((r) => unwrapList<RawAuditLogDto>(r.data).items.map(toAuditLogEntry)),
};
